import { TFunction } from 'i18next';
import { useState } from 'react';
import {
  ReservationResponse,
  Workplace,
  WorkplaceReservationsToCancel,
} from 'src/api/wa/store/models/workplace';
import Button from 'src/ui/wards/common/button/Button';

interface CancelReservationCellProps {
  row: Workplace;
  cancelWorkplaceReservation: (
    reservationsDetails: WorkplaceReservationsToCancel[]
  ) => Promise<ReservationResponse[] | null | undefined>;
  notify: (messageKey: string) => void;
  t: TFunction<'translation', undefined>;
}

export const CancelReservationCell = ({
  row,
  cancelWorkplaceReservation,
  notify,
  t,
}: CancelReservationCellProps) => {
  const [isCancelling, setIsCancelling] = useState(false);

  return (
    <div className="p-2">
      {(row.details?.reservations?.length ?? 0) !== 0 ? (
        <Button
          title={t('wards.desktop.unaddressedPropertiesList.cancelReservation')}
          className="text-xs"
          disabled={isCancelling}
          onClick={async () => {
            if (isCancelling) return;

            const reservationParams = [
              {
                branchCode: row.branchCode,
                customerId: row.customerId,
                reservations: row.details.reservations,
              },
            ];

            try {
              setIsCancelling(true);
              const response = await cancelWorkplaceReservation(reservationParams);
              if (response) {
                notify('wards.sites.cancelReservationSuccess');
              } else {
                notify('wards.sites.cancelReservationFailed');
                setIsCancelling(false);
              }
            } catch (error) {
              notify('wards.sites.cancelReservationFailed');
              console.log(error);
              setIsCancelling(false);
            }
          }}
        />
      ) : (
        ''
      )}
    </div>
  );
};
